<template>
    <div class="assemble">
        <!-- 选项卡 -->
        <div class="flex align-center nav">
            <div class="flex align-center nav__item" :class="loads.category_id==item.id?'active':''" v-for="(item,index) in category" :key="index" @click="loads.category_id=item.id">
                <span class="fs_32" :class="loads.category_id==item.id?'c_1a fw_600':'c_66'">{{item.name}}</span>
            </div>
        </div>
        <div class="swiper-box">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item,index) in carousel" :key="index"><img :src="item.image" @click="link(item.link_url)"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        
        <!-- 商品列表 -->
        <div class="row-box">
            <div class="flex row__item" v-for="item in list" :key="item.id" v-link="'/Assemble/Detail/'+item.id">
                <img :src="item.cover_img" alt="">
                <div class="flex__null__around row__info">
                    <span class="fs_30 c_1a lh_40 ellipsis_two">{{item.name}}</span>
                    <div v-if="item.status==1" class="tips">
                        <span class="fs_24 c_ff">已拼{{item.sales}}份</span>
                    </div>
                    <div v-else-if="item.status==2" class="tips tips--no">
                        <span class="fs_24 c_ff">未开始</span>
                    </div>
                    <div v-else class="tips tips--no">
                        <span class="fs_24 c_ff">已结束</span>
                    </div>
                    <div>
                        <span class="fs_22 c_main">¥</span>
                        <span class="fs_30 c_main">{{item.price_group}}</span>
                        <span class="fs_26 c_98 line_through">¥{{item.price_original}}</span>
                    </div>
                </div>
            </div>
        </div>
        <jc-list :url="'/Collage/getIndexList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name:'Assemble',
    data(){
        return {
            category:[],
            carousel:[],
            list:[],
            loads:{page:1,category_id:''},
            swiperOption: {
                initialSlide :1,
                loop : true,
                autoplay: 3000,
                autoplayDisableOnInteraction:false,
                pagination: '.swiper-pagination',
            }
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        // 离交跳转到列表页
        linkList(){
            if(this.keyword){
                this.$store.commit('setIntegral',this.keyword);
                this.$router.push('/Integral/List/0');
            }
        },
        // 跳转
        link(url){
            if(url){
                window.location.href=url;
            }
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Collage/getIndexData',{
            user_id: localStorage.user_id
        }).then(
            res=>{
                this.category=res.data.data.category;
                this.loads.category_id=res.data.data.category[0].id;
                this.carousel=res.data.data.carousel;
            }
        )
    }
}
</script>

<style scoped>
/* nav */
.nav{
    position: fixed;
    top: 0;
    width: 100%;
    height: 100px;
    padding: 0 30px 10px;
    z-index: 2;
    background: #fff;
    overflow-x: auto;
}
.nav__item{
    margin-left: 48px;
    white-space: nowrap;
}
.nav__item:first-child{
    margin-left: 0;
}
.nav__item.active{
    height: 90px;
    border-bottom: 4px solid #F93A42;
}
.swiper-box{
    margin-top: 100px;
    background: #fff;
}
.swiper-box img{
    width:100%;
    height:300px;
}
/* 商品 */
.row-box{
    overflow: hidden;
    padding: 0 30px 30px;
    background: #fff;
}
.row__item{
    margin-top: 30px;
}
.row__item img{
    width: 250px;
    height: 250px;
    border-radius: 10px;
}
.row__info{
    width: 410px;
    margin-left: 30px;
}
.tips{
    width: max-content;
    padding: 6px 10px;
    border-radius:4px;
    background: #F93A42;
}
.tips--no{
    background: #cbcbcb;
}
</style>




// WEBPACK FOOTER //
// src/pages/assemble/Index.vue